"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const styled_1 = __importDefault(require("../utils/styled"));
const useSticky_1 = __importDefault(require("../useSticky/useSticky"));
const isRefRefObject_1 = require("../utils/isRefRefObject");
const Container = styled_1.default.div `
  position: ${({ position }) => position};
  top: ${({ top }) => top};
  left: ${({ left }) => left};
  max-height: 50vh;
  overflow: auto;
  box-shadow: ${({ theme }) => theme.shadows.contextMenu};
  min-width: fit-content;
  width: ${({ width }) => width};
  max-width: 90vw;
  min-height: ${({ rowHeight }) => rowHeight}px;
  display: grid;
  grid-template-rows: repeat(${({ numRows }) => numRows}, max-content);
  background-color: ${({ theme }) => theme.color.white};
  padding: ${({ theme }) => theme.space.small}px 0;

  ${({ theme, anchored }) => (anchored ? "" : `z-index: ${theme.zIndex.selectOptions + 2};`)}
`;
const ContextMenuPopout = React.forwardRef(({ align, children, condensed, container, embedChildrenInMenu, numRows, rowHeight, anchored }, forwardRef) => {
    const $fallback = React.useRef(null);
    const $el = isRefRefObject_1.isRefRefObject(forwardRef) ? forwardRef : $fallback;
    const initialValue = {
        position: "absolute",
        left: align === "left" ? "0" : "auto",
        top: embedChildrenInMenu ? "0" : "100%",
        width: "100%",
    };
    const { left, position, top, width } = useSticky_1.default({
        $el: $el,
        initialValue,
    });
    const areWeFixedYet = position === "fixed";
    const popOut = (React.createElement(Container, { align: align, condensed: condensed, numRows: numRows, rowHeight: rowHeight, anchored: anchored, left: anchored ? initialValue.left : left, width: anchored ? initialValue.width : width, top: anchored ? initialValue.top : top, position: anchored ? initialValue.position : position, ref: $el, role: "listbox" }, children));
    return !anchored && areWeFixedYet && container && container.current
        ? react_dom_1.createPortal(popOut, container.current)
        : popOut;
});
exports.default = ContextMenuPopout;
//# sourceMappingURL=ContextMenu.Popout.js.map